<template>
     <v-container fluid>
    <div class="tables-basic">
      <h1 class="page-title mt-10 mb-6">Arrendadoras</h1>
      <v-row>
        <v-col cols="12">
          <v-card class="employee-list mb-1">
            <v-card-title class="pa-6 pb-3">
            
              <v-row >
    <v-dialog
      v-model="dialogNuevaArrendadora"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
           <v-btn  v-bind="attrs"  v-on="on" rounded color="primary" small dark>Nueva Arrendadora</v-btn>
      </template>
      <v-card>
        <v-card-title>
         <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="arrendadora" label="Arrendadora"></v-text-field>
                    <div v-if="submited && !$v.arrendadora.required">
                        <v-alert dense v-model="alert" dismissible color="red" border="left" elevation="2" colored-border icon="mdi-alert-octagon">
                            <strong>Error</strong> Campo Arrendadora es requerido
                        </v-alert>
                    </div>   
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="razonSocial" label="Razon Social"></v-text-field>
                    <div v-if="submited && !$v.razonSocial.required">
                        <v-alert dense v-model="alert" dismissible color="red" border="left" elevation="2" colored-border icon="mdi-alert-octagon">
                            <strong>Error</strong> Campo Razon Social es obligatorio
                        </v-alert>
                    </div>
              </v-col>
             
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cerrarModalArrendadora()"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="guardar()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                clearable
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
            
              dense
              :headers="headers"
              :items="arrendadoras"
              :search="search"
              item-key="nombreComercial"
              
              >
                <template v-slot:[`item.action`]="{item}">
          <v-icon @click="editItem(item)" small class="mr-2" >mdi-border-color</v-icon>
          <template >
            <v-icon  class="mr-2" >mdi-delete</v-icon>
          </template>
        </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
     </v-container>
</template>

<script>
import axios from 'axios'
import {required} from "vuelidate/lib/validators"

export default {
    validations:{
        razonSocial:{
            required
        },
    
        arrendadora:{
            required,
        },
     
    },
    data(){
        return{
            headers: [
                { text: "Actions", value: "action", sortable: false },
                { text: "Razon Social", value: "razonSocial", sortable: true },
                { text: "Arrendadora", value: "arrendadora", sortable: true },    
            ],
            arrendadoras:[],
            search:'',
            dialogNuevaArrendadora:false,
            razonSocial:'',
            arrendadora:'',
             editedIndex: -1,
            nombreComercial:'',
            representante:'',
            submited:'',
            alert:'',
        }
    },
    computed: {
        formTitle() {
        return this.editedIndex === -1 ? "Nueva Arrendadora" : "Editar Arrendadora";
        }
    },
    created(){
        this.listar()
    },
    methods:{
        listar(){
            let me = this;
            axios.get('/arrendadora/list/').then(function (response){
                me.arrendadoras = response.data
                console.log(response.data)
            }).catch(function(error){
                console.log(error)
            })
        },
        limpiar(){
            this.arrendadora='',
            this.razonSocial=''
        },
        guardar(){
            let me = this
            if(this.editedIndex>-1){
               
                axios.put('/arrendadora/update',{'_id':this._id,'razonSocial':this.razonSocial,'arrendadora':this.arrendadora})
                .then(function(response){
                    console.log(response)
                    me.listar()
                    me.dialogNuevaArrendadora=false;
                    me.addSuccessNotification('Arrendadora actualizada')
                    me.limpiar()
                })
                .catch(function(error){
                    console.log(error)
                })
            }else{
            this.submited = true
            this.$v.$touch();
                  if(this.$v.$invalid){
                    me.addErrorNotification()
                    return false
                  }
            axios.post('/arrendadora/add',{'razonSocial':this.razonSocial,'arrendadora':this.arrendadora})
            .then(function(response){
                console.log(response)
                me.listar()
                me.dialogNuevaArrendadora=false;
                me.addSuccessNotification('Arrendadora agregada')
                me.limpiar()
            })
            .catch(function(error){
                console.log(error)
            })
            }
        },
        editItem(item) {
            this._id = item._id;
            this.arrendadora = item.arrendadora;
            this.razonSocial = item.razonSocial;
            
            this.editedIndex = 1;

            this.dialogNuevaEmpresa = true;
        },
        addSuccessNotification(mensaje) {
                this.$toast.success(mensaje, {
                position: 'top-right',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true
            });
        },
         addErrorNotification() {
                this.$toast.error("Error, verifique los campos ingresados", {
                position: 'top-right',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true
            });   
        },
        cerrarModalArrendadora(){
            this.dialogNuevaArrendadora =false;
            this.limpiar()
            this.editedIndex = -1
        }

    }
}
</script>
